import React from "react";
import Navbar from "../components/Navbar";
import Form from "../components/Form";

function Home() {
  return (
    <div>
      <Navbar />
      <Form />
    </div>
  );
}

export default Home;
